import { render, staticRenderFns } from "./MyGoods.vue?vue&type=template&id=3c976c10&"
import script from "./MyGoods.vue?vue&type=script&lang=ts&"
export * from "./MyGoods.vue?vue&type=script&lang=ts&"
import style0 from "./MyGoods.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports